const e=["initial","xs","sm","md","lg","xl"];export{e as breakpoints};
//# sourceMappingURL=prop-def.js.map
